<template>
  <div class="modal fade show" tabindex="-1" id="modal-popup" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-xl" @click.stop>
      <div class="modal-content bg-transparent border-0">
        <div class="modal-body d-flex justify-content-center align-items-center px-3">
          <div class="position-relative cursor-pointer">
            <img :src="data.image" alt="popup" class="img-fluid" @click="handlePopupClick">
            <button type="button" class="btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close">
              <i class="ri-close-circle-line"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { Modal } from 'bootstrap'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup () {
    const router = useRouter()

    const handlePopupClick = () => {
      // Close the modal first
      const modal = document.getElementById('modal-popup')
      if (modal) {
        const bootstrapModal = Modal.getInstance(modal)
        if (bootstrapModal) {
          bootstrapModal.hide()
        }
      }

      router.push('/popup')
    }

    return {
      handlePopupClick
    }
  }
}
</script>

<style scoped lang="scss">
.modal{
  z-index: 10000;
}

.modal-dialog {
  max-width: 90vw;
  max-height: 90vh;
}

.modal-body img {
  max-height: 80vh;
  object-fit: contain;
}

.btn-close {
  top: -15px;
  right: -15px;
  background-color: #000;
  border-radius: 50%;
  opacity: 0.8;
  transition: opacity 0.2s;
  z-index: 10;
  color: #fff;
  font-size: 30px;
  line-height: 30px;
  padding: 5px;

  &:hover {
    opacity: 1;
    color: #fff;
  }

  @media (min-width: 768px) {
    top: -15px;
    right: -15px;
    font-size: 35px;
    line-height: 35px;
  }
}
</style>
